const selectors = {
    openBtn: '.js-mobile-menu-open-btn',
    closeBtn: '.js-mobile-menu-close-btn',
    menu: '.js-mobile-menu',
    overlay: '.js-mobile-menu-overlay',
    mobileLink: '.js-mobile-menu-link'
};

const states = {
    active: 'is-active'
};

const closeMenu = () => {
    $(selectors.overlay).removeClass(states.active);
    $(selectors.menu).removeClass(states.active);
    $(selectors.openBtn).removeClass(states.active);
    $(selectors.closeBtn).removeClass(states.active);
};

const closeMobileMenu = () => {
    const $link = $(selectors.mobileLink);

    if ($link.length < 1) {
        return;
    }

    $link.each((index, item) => $(item).on('click', closeMenu));
};

export default closeMobileMenu;
